const styleSheet = () => ({
  body: {
    backgroundColor: '#000',
  },
  container: {
    border: 'solid dodgerblue 10px',
    marginLeft: '20%',
    marginRight: '20%',
    marginTop: '5%',
    borderRadius: '5px',
    padding: '10%',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    fontSize: '14px',
  },
  h2: {
    textAlign: 'center',
    color: 'dodgerblue',
  },
  p: {
    color: '#808080',
    fontWeight: 500,
  },
  a: {
    color: '#808080',
  },
});

export default styleSheet;
